export default __webpack_public_path__ + "static/media/flag-ethiopia.74ec2d59.svg";